// import animation from '@helpers/animation';
import { API_URLS } from '@helpers/api';
import { withMotionMax } from '@hoc/withMotionMax';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
// import { useInView } from '@hooks/useInView';
import SearchCard from '@stories/Components/Cards/SearchCard/SearchCard';
import FilteredListing from '@stories/Components/FilteredListing/FilteredListing';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import { useReducedMotion } from 'framer-motion';
import { debounce } from 'lodash';
import queryString from 'query-string';
import React, { useState } from 'react';
import { useFirstMountState } from 'react-use';
import { ArrayParam, BooleanParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import S from './Search.styles';
const Search = ({ pageContext, favourites = false, filterTitle, initialData, placeholder, searchTerm = '', sortByOptions, categoryFilter, tailored = false, topicFilter, }) => {
    const isFirstMount = useFirstMountState();
    const [currentSearchTerm, setCurrentSearchTerm] = useState(searchTerm);
    const [updatedSearchTerm, setUpdatedSearchTerm] = useState(searchTerm);
    // const [refInView, inView] = useInView<HTMLDivElement>(
    //   {
    //     rootMargin: animation.inView.rootMargin,
    //   },
    //   false,
    //   pageContext?.isEditMode,
    // );
    const shouldReduceMotion = useReducedMotion();
    const debouncedSearch = React.useRef(debounce((updatedSearchTerm) => {
        setCurrentSearchTerm(updatedSearchTerm);
    }, 1000)).current;
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        favourites: BooleanParam,
        pageIndex: NumberParam,
        category: withDefault(ArrayParam, []),
        sortBy: StringParam,
        tailored: BooleanParam,
        topic: withDefault(ArrayParam, []),
        sort: StringParam,
    });
    const uniqCatArray = new Set(queryParams.category);
    const categoryArray = [...uniqCatArray];
    const uniqTopicArray = new Set(queryParams.topic);
    const topicArray = [...uniqTopicArray];
    // Create filter value structure.
    const filterValue = {
        category: queryString.stringify({ categoryType: categoryArray }) ?? '',
        topic: queryString.stringify({ categoryType: topicArray }) ?? '',
        sort: queryParams.sort ?? '',
    };
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    const pageSize = 12;
    // Get sort by or default.
    const sortByValue = queryParams.sortBy ?? sortByOptions[0].value;
    // Construct API url.
    const parameters = queryString.stringify({
        docId: pageContext?.documentId,
        favourites: favourites,
        pageIndex: pageIndex,
        pageSize: 12,
        searchTerm: currentSearchTerm,
        category: categoryArray,
        sortBy: sortByValue,
        tailored: tailored,
        topic: topicArray,
        sort: filterValue.sort,
    });
    const apiUrl = `${API_URLS.search}?${parameters}`;
    // Fetch data.
    const { data, loading, error } = useApi(apiUrl, !isFirstMount);
    // Get items from response or initial items.
    const items = data?.items ?? initialData.items;
    const totalItems = data?.totalItems ?? initialData.totalItems;
    categoryFilter = categoryFilter ? categoryFilter : data?.categoryFilter;
    topicFilter = topicFilter ? topicFilter : data?.topicFilter;
    React.useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [pageIndex]);
    function setSearch(val) {
        debouncedSearch(val);
    }
    return (React.createElement(S.Container, { flush: "bottom", fullWidth: true },
        React.createElement(SiteWide, null,
            React.createElement(S.SearchResult, null,
                "You have ",
                totalItems,
                " results for ",
                React.createElement(S.Highlight, null, currentSearchTerm)),
            React.createElement(S.SearchContainer, null,
                React.createElement(S.Input, { placeholder: placeholder ?? '', type: "search", role: updatedSearchTerm, value: updatedSearchTerm, onChange: (event) => {
                        setUpdatedSearchTerm(event.target.value);
                        setSearch(event.target.value);
                    } }),
                React.createElement(S.Submit, { type: "submit", onClick: () => setCurrentSearchTerm(currentSearchTerm) },
                    React.createElement(S.SubmitLabel, null, "Search"),
                    React.createElement(S.SubmitIcon, null)))),
        React.createElement(FilteredListing, { error: error, filtersProps: {
                filters: [],
                filterValue: filterValue,
                checkboxFilters: [categoryFilter ? categoryFilter : null, topicFilter ? topicFilter : null],
                categoryValues: queryParams.category,
                sortByOptions: sortByOptions,
                sortByValue: sortByValue,
                topicValues: queryParams.topic,
                title: filterTitle,
                onCheckBoxChange: (key, val) => setQueryParams({ [key]: val, pageIndex: 1 }),
                onFilterChange: (key, val) => setQueryParams({ [key]: val, pageIndex: 1 }),
                onSortChange: (val) => setQueryParams({ sortBy: val, pageIndex: 1 }),
            }, items: items, loading: loading, pageIndex: pageIndex, pageSize: pageSize, renderItems: (items) => (React.createElement(S.ItemList
            // ref={refInView}
            , { 
                // ref={refInView}
                animate: 'visible', initial: 'visible', variants: {
                    hidden: {
                        transition: {
                            type: 'tween',
                            ease: [0.45, 0.01, 0.1, 1],
                        },
                    },
                    visible: {
                        transition: {
                            type: 'tween',
                            ease: [0.45, 0.01, 0.1, 1],
                            delayChildren: 0.3,
                            staggerChildren: 0.1
                        },
                    },
                } }, items.map((item) => (React.createElement(S.Item, { key: item.id, variants: {
                    hidden: {
                        opacity: 0,
                        translateY: shouldReduceMotion ? 0 : 20,
                    },
                    visible: {
                        opacity: 1,
                        translateY: 0,
                        transition: {
                            ease: [0.45, 0.01, 0.1, 1],
                            duration: 1,
                        },
                    }
                } },
                React.createElement(SearchCard, { ...item })))))), totalItems: totalItems, onPageChange: (pageIndex) => {
                setQueryParams({ pageIndex });
            } })));
};
export default withMotionMax(withQueryParams(Search));
